import React, { useState } from "react";
import "./style.css";
import API from "../../utils/API";
import fire from "../../config/Fire";
import cogoToast from "@successtar/cogo-toast";

function CreateAgentRow({ generateNewRow }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    residentState: "",
    docName: "",
    document: ""
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const signup = (e) => {
    e.preventDefault();
    const password = "Fawn2076";
    fire
      .auth()
      .createUserWithEmailAndPassword(formData.email, password)
      .then((data) => {
        console.log("Successfully created Agent");
        console.log(data);

        API.saveAgent({
          uid: data.user.uid,
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: data.user.email,
          telephone: formData.telephone,
          residentState: formData.residentState
        }).then((res) => {
          console.log(res.data);
          cogoToast.success("Successfully Created a New Agent!");
          alert("Successfully Created a New Agent!");
          generateNewRow(res.data);
          if (formData.document.length > 0) {
            if (formData.docName.length > 0) {
              API.createDocumentForAgent(res.data._id, {
                docName: formData.docName,
                document: formData.document,
                policyid: res.data._id,
                type: "agent"
              })
                .then((res) => {
                  console.log(res.data);
                  cogoToast.success("Uploaded Agent Document");
                })
                .catch((err) => console.log(err));
            } else {
              API.createDocumentForAgent(res.data._id, {
                docName: "Agent Document",
                document: formData.document,
                policyid: res.data._id,
                type: "agent"
              })
                .then((res) => {
                  console.log(res.data);
                  cogoToast.success("Uploaded Agent Document");
                })
                .catch((err) => console.log(err));
            }
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    setFormData((prev) => ({
      ...prev,
      docName: event.target.files[0].name
    }));

    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          document: res
        }));
      });
    }
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          style={{ width: "100px" }}
          value={formData.firstName}
          onChange={handleInputChange}
          name="firstName"
          placeholder="First"
        />
      </td>

      <td>
        <input
          type="text"
          style={{ width: "100px" }}
          value={formData.lastName}
          onChange={handleInputChange}
          name="lastName"
          placeholder="Last"
        />
      </td>
      <td>
        <input
          name="fileData"
          style={{ width: "200px" }}
          type="file"
          onChange={fileSelectedHandler}
        />
      </td>
      <td>
        <input
          style={{ width: "150px" }}
          type="text"
          value={formData.email}
          onChange={handleInputChange}
          name="email"
          placeholder="E-mail"
        />
      </td>
      <td>
        <input
          type="text"
          style={{ width: "150px" }}
          value={formData.telephone}
          onChange={handleInputChange}
          name="telephone"
          placeholder="Phone #"
        />
      </td>
      <td>
        <input
          style={{ width: "150px" }}
          maxLength="2"
          type="text"
          value={formData.residentState}
          onChange={handleInputChange}
          name="residentState"
          placeholder="Resident State"
        />
      </td>
      <td>
        <input
          type="text"
          style={{ width: "300px" }}
          value={formData.address}
          onChange={handleInputChange}
          name="address"
          placeholder="Address"
        />
      </td>
      <td>
        <button className="btn-success btn" onClick={(e) => signup(e)}>
          Create
        </button>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  );
}

export default CreateAgentRow;
